/*
 * gramms LP1 — Buy box plan switcher.
 *
 * The form posts to /cart/add with the variant id and, when a subscription is
 * chosen, a `selling_plan` value. Shopify and Recharge take it from there.
 * This only keeps the displayed price and the button label in sync with the
 * selected radio; every price string is rendered by Liquid and carried on the
 * radio as a data attribute, so nothing is computed or formatted here.
 */
(function () {
  function setup(root) {
    if (!root || root.dataset.lp1BuyReady === 'true') return;
    root.dataset.lp1BuyReady = 'true';

    var radios = root.querySelectorAll('[data-lp1-buy-plan]');
    var priceNow = root.querySelector('[data-lp1-buy-price-now]');
    var priceWas = root.querySelector('[data-lp1-buy-price-was]');
    var priceUnit = root.querySelector('[data-lp1-buy-price-unit]');
    var cta = root.querySelector('[data-lp1-buy-cta]');
    var renewal = root.querySelector('[data-lp1-buy-renewal]');
    if (!radios.length) return;

    function apply(radio) {
      if (!radio) return;
      var d = radio.dataset;
      if (priceNow) priceNow.textContent = d.price || '';
      if (priceWas) priceWas.textContent = d.compareAt || '';
      if (priceUnit) priceUnit.textContent = d.unitPrice || '';
      if (cta && d.cta) cta.textContent = d.cta;
      /* The one-time radio posts an empty selling_plan: nothing renews. */
      if (renewal) renewal.hidden = !radio.value;
    }

    Array.prototype.forEach.call(radios, function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) apply(radio);
      });
      if (radio.checked) apply(radio);
    });

    bindForm(root);
  }

  /*
   * Without this the form posts natively and Shopify answers with a redirect to
   * /cart, which skips the theme's drawer. Baseline opens the drawer when
   * `baseline:cart:afteradditem` fires on document.body, and its cart sections
   * re-render from the `sections` the Ajax API returns — so the request has to
   * carry the same payload the theme's own ProductForm sends.
   *
   * Anything that goes wrong falls back to submitting natively: landing on the
   * cart page is worse than the drawer, but far better than a dead button.
   */
  function bindForm(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    var cta = root.querySelector('[data-lp1-buy-cta]');
    if (!form) return;

    var panel = root.querySelector('[data-lp1-buy-after]');
    var after = panel ? panel.dataset.lp1BuyAfter : 'cart';

    form.addEventListener('submit', function (event) {
      /* 'cart' lets the native POST run, which is Shopify's own redirect to the
         cart page — nothing to intercept. */
      if (after !== 'drawer') return;
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();

      var body = new FormData(form);
      body.append('sections', 'cart-items,cart-footer,cart-item-count');
      body.append('sections_url', window.location.pathname);

      var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';

      if (cta) cta.setAttribute('aria-busy', 'true');

      fetch(url, {
        method: 'POST',
        body: body,
        credentials: 'same-origin',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message || 'Add to cart failed');

          document.body.dispatchEvent(
            new CustomEvent('baseline:cart:afteradditem', {
              bubbles: true,
              detail: { response: data, sourceId: form.getAttribute('id') }
            })
          );
        })
        .catch(function () {
          form.submit();
        })
        .then(function () {
          if (cta) cta.removeAttribute('aria-busy');
        });
    });
  }

  function setupAll(scope) {
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll('[data-lp1-buy]'),
      setup
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setupAll(); });
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', function (event) { setupAll(event.target); });
})();
